module.exports = __webpack_public_path__ + "213ea1d9a9f53bf14d8230b2e94f2f54.pdf";